export default __webpack_public_path__ + "static/media/minkyo.5c748e57.jpeg";